// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomePage — hero slider
   Palette: purple #3b003d · gold #e0a83d · cream · soft lilac
   No :root variables, no green.
   ============================================================ */

.impac_home_pg_section {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8e9fd 100%);
  font-family: "Manrope", "Roboto", sans-serif;
  color: #3b003d;
}

.impac_home_pg_section::before {
  content: "";
  position: absolute;
  top: -120px;
  right: -140px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(224, 168, 61, 0.22) 0%, rgba(224, 168, 61, 0) 70%);
  pointer-events: none;
}

/* ---------- Stage: all slides share one grid cell ---------- */

.impac_home_pg_stage {
  position: relative;
  display: grid;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

.impac_home_pg_slide {
  grid-area: 1 / 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.08fr);
  align-items: start; /* video top lines up with the tag */
  column-gap: 56px;
  row-gap: 40px;
  padding: 100px 0 80px; /* top space also holds the top badge */
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.55s ease,
    transform 0.7s cubic-bezier(0.22, 1, 0.36, 1),
    visibility 0s linear 0.7s;
}

.impac_home_pg_slide_prev {
  transform: translateX(-60px);
}

.impac_home_pg_slide_next {
  transform: translateX(60px);
}

.impac_home_pg_slide_active {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(0);
  transition-delay: 0s;
  z-index: 2;
}

/* ---------- Staggered reveal ---------- */

.impac_home_pg_reveal {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.impac_home_pg_slide_active .impac_home_pg_reveal {
  opacity: 1;
  transform: translateY(0);
  transition:
    opacity 0.7s ease var(--d, 0ms),
    transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);
}

/* ---------- Left column ---------- */

.impac_home_pg_info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  width: 100%;
}

.impac_home_pg_tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(224, 168, 61, 0.55);
  box-shadow: 0 4px 14px rgba(59, 0, 61, 0.08);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #3b003d;
}

.impac_home_pg_tag_text {
  display: inline-block;
  animation: impac_home_pg_tag_swap 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes impac_home_pg_tag_swap {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.impac_home_pg_tag_dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e0a83d;
  box-shadow: 0 0 0 4px rgba(224, 168, 61, 0.25);
}

.impac_home_pg_heading {
  margin: 20px 0 16px;
  max-width: 640px;
  font-size: clamp(28px, 3.3vw, 44px);
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: -0.015em;
  color: #3b003d;
  text-align: left;
  text-wrap: balance;
}

.impac_home_pg_desc {
  margin: 0 0 28px;
  max-width: 600px;
  font-size: 16.5px;
  line-height: 1.75;
  color: #4e3a50;
  text-align: justify;
  text-justify: inter-word;
  hyphens: auto;
  -webkit-hyphens: auto;
  overflow-wrap: break-word;
}

/* ---------- Picker ---------- */

.impac_home_pg_picker {
  width: 100%;
  max-width: 600px;
  margin-bottom: 30px;
}

.impac_home_pg_question {
  margin: 0 0 4px;
  font-size: 17px;
  font-weight: 800;
  color: #3b003d;
}

.impac_home_pg_hint {
  margin: 0 0 14px;
  font-size: 13.5px;
  color: #7a677c;
  text-align: left;
}

.impac_home_pg_chips {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 12px;
}

.impac_home_pg_chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 44px;
  padding: 0 22px;
  border: 1px solid #e6dcfa;
  border-radius: 8px;
  background: #ffffff;
  /* soft lilac "step" under the button + blurred glow, like the design */
  box-shadow:
    0 4px 0 -1px rgba(190, 168, 236, 0.55),
    0 10px 18px rgba(74, 26, 158, 0.12);
  font-family: inherit;
  font-size: 14.5px;
  font-weight: 700;
  line-height: 1;
  color: #4a1a9e;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  -webkit-tap-highlight-color: transparent;
  opacity: 0;
  transform: translateY(14px) scale(0.96);
  transition:
    background 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease,
    opacity 0.2s ease,
    transform 0.2s ease;
}

.impac_home_pg_slide_active .impac_home_pg_chip {
  opacity: 1;
  transform: translateY(0) scale(1);
  transition:
    background 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease,
    opacity 0.5s ease calc(380ms + var(--i, 0) * 55ms),
    transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) calc(380ms + var(--i, 0) * 55ms);
}

/* purple fill that sweeps in on hover */
.impac_home_pg_chip::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);
  transform: translateX(-101%);
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.impac_home_pg_slide_active .impac_home_pg_chip:hover {
  color: #ffffff;
  border-color: #40159f;
  box-shadow:
    0 4px 0 -1px rgba(122, 31, 196, 0.35),
    0 14px 24px rgba(74, 26, 158, 0.32);
  transform: translateY(-3px);
  transition-delay: 0s;
}

.impac_home_pg_chip:hover::before {
  transform: translateX(0);
}

.impac_home_pg_chip:active {
  transform: scale(0.96);
}

/* arrow / tick inside the chip: always visible */
.impac_home_pg_chip_icon {
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.impac_home_pg_chip:hover .impac_home_pg_chip_icon {
  transform: translateX(3px);
}

.impac_home_pg_chip_selected .impac_home_pg_chip_icon {
  animation: impac_home_pg_tick 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.impac_home_pg_chip_selected,
.impac_home_pg_slide_active .impac_home_pg_chip_selected:hover {
  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);
  border-color: #40159f;
  color: #ffffff;
  box-shadow:
    0 4px 0 -1px rgba(122, 31, 196, 0.35),
    0 12px 22px rgba(74, 26, 158, 0.34);
}

.impac_home_pg_chip_selected::before {
  display: none;
}

.impac_home_pg_chip_selected:hover .impac_home_pg_chip_icon {
  transform: none;
}

@keyframes impac_home_pg_tick {
  from { opacity: 0; transform: scale(0.3) rotate(-30deg); }
  to   { opacity: 1; transform: scale(1) rotate(0); }
}

.impac_home_pg_chip:focus-visible,
.impac_home_pg_btn_primary:focus-visible,
.impac_home_pg_btn_secondary:focus-visible,
.impac_home_pg_sound_btn:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 3px;
}

/* ---------- Buttons ---------- */

.impac_home_pg_actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 38px;
}

.impac_home_pg_btn_primary,
.impac_home_pg_btn_secondary {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 28px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.impac_home_pg_btn_primary {
  border: 2px solid #3b003d;
  background: #3b003d;
  color: #faf6ec;
  box-shadow: 0 10px 24px rgba(59, 0, 61, 0.28);
}

.impac_home_pg_btn_primary::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: #e0a83d;
  transform: translateY(101%);
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.impac_home_pg_btn_primary:hover {
  color: #3b003d;
  border-color: #e0a83d;
  transform: translateY(-3px);
  box-shadow: 0 14px 30px rgba(224, 168, 61, 0.45);
}

.impac_home_pg_btn_primary:hover::before {
  transform: translateY(0);
}

.impac_home_pg_btn_primary .impac_home_pg_arrow {
  width: 14px;
  margin-left: 0;
  opacity: 1;
}

.impac_home_pg_btn_primary:hover .impac_home_pg_arrow {
  transform: translateX(5px);
}

.impac_home_pg_btn_secondary {
  border: 2px solid rgba(59, 0, 61, 0.3);
  background: transparent;
  color: #3b003d;
}

.impac_home_pg_btn_secondary:hover {
  border-color: #3b003d;
  background: #ffffff;
  transform: translateY(-3px);
  box-shadow: 0 10px 22px rgba(59, 0, 61, 0.14);
}

.impac_home_pg_btn_primary:active,
.impac_home_pg_btn_secondary:active {
  transform: translateY(0) scale(0.97);
}

/* ---------- Stats ---------- */

.impac_home_pg_stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 640px;
  padding-top: 26px;
  border-top: 1px solid rgba(59, 0, 61, 0.14);
}

.impac_home_pg_stat {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.impac_home_pg_stat_value {
  margin: 0 0 6px;
  font-size: clamp(22px, 2.2vw, 30px);
  font-weight: 800;
  line-height: 1.1;
  color: #3b003d;
}

.impac_home_pg_stat_label {
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 1.5;
  color: #5d4a5f;
  text-align: left;
  hyphens: auto;
  -webkit-hyphens: auto;
}

.impac_home_pg_stat_source {
  margin-top: auto;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #b8861f;
}

/* ---------- Right: video ---------- */

.impac_home_pg_visual {
  position: relative;
  justify-self: end;
  align-self: start;
  width: 100%;
  max-width: 720px;
  min-width: 0;
  padding: 0 16px 30px 0;
}

/* gold frame sitting behind the card, offset down-right */
.impac_home_pg_visual::before {
  content: "";
  position: absolute;
  top: 16px;
  right: 0;
  bottom: 14px;
  left: 16px;
  border: 2px solid #e0a83d;
  border-radius: 30px;
  opacity: 0;
  transform: translate(14px, -14px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.impac_home_pg_slide_active .impac_home_pg_visual::before {
  opacity: 0.7;
  transform: translate(0, 0);
  transition: opacity 0.8s ease 0.5s, transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s;
}

.impac_home_pg_video_card {
  position: relative;
  width: 100%;
  /* FIXED ratio: size never jumps when a video loads.
     Video uses object-fit: cover so it always fills the whole card. */
  aspect-ratio: 5 / 4;
  border-radius: 28px;
  overflow: hidden;
  background: #3b003d;
  box-shadow: 0 30px 60px rgba(59, 0, 61, 0.24), 0 0 0 1px rgba(224, 168, 61, 0.35);
  clip-path: inset(0 0 100% 0 round 28px);
  transition: clip-path 0.2s ease;
  transform: translateZ(0); /* keeps rounded clipping on video in Safari */
}

.impac_home_pg_slide_active .impac_home_pg_video_card {
  clip-path: inset(0 0 0 0 round 28px);
  transition: clip-path 1.1s cubic-bezier(0.77, 0, 0.175, 1) 0.15s;
}

.impac_home_pg_video_card::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(59, 0, 61, 0) 60%, rgba(59, 0, 61, 0.32) 100%);
  pointer-events: none;
}

.impac_home_pg_video {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  background: #3b003d;
  transform: scale(1.12);
  transition: transform 0.2s ease;
  pointer-events: none; /* no native video controls/menus on hover */
}

.impac_home_pg_slide_active .impac_home_pg_video {
  transform: scale(1);
  transition: transform 1.6s cubic-bezier(0.22, 1, 0.36, 1) 0.15s;
}

.impac_home_pg_slide_active .impac_home_pg_video_card:hover .impac_home_pg_video {
  transform: scale(1.04);
  transition: transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);
}

/* ---------- Sound button (inside video card, bottom-right) ---------- */

.impac_home_pg_sound_btn {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 16px 0 12px;
  border: 1px solid rgba(224, 168, 61, 0.6);
  border-radius: 999px;
  background: rgba(59, 0, 61, 0.72);
  backdrop-filter: blur(8px);
  color: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  pointer-events: auto;
  transition:
    background 0.3s ease,
    color 0.3s ease,
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.impac_home_pg_sound_btn:hover {
  background: #e0a83d;
  color: #3b003d;
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
}

.impac_home_pg_sound_btn:active {
  transform: scale(0.96);
}

.impac_home_pg_sound_btn_on {
  background: #e0a83d;
  color: #3b003d;
}

.impac_home_pg_sound_btn_on:hover {
  background: #ffffff;
}

.impac_home_pg_sound_btn svg {
  flex-shrink: 0;
}

/* ---------- Floating badges ---------- */

.impac_home_pg_badge {
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  max-width: 250px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(224, 168, 61, 0.5);
  box-shadow: 0 16px 36px rgba(59, 0, 61, 0.2);
  opacity: 0;
  transform: translateY(20px) scale(0.9);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/* sits fully above the video so it never covers it */
.impac_home_pg_badge_top {
  top: -72px;
  right: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.impac_home_pg_badge_bottom {
  bottom: 0;
  left: 0;
}

.impac_home_pg_slide_active .impac_home_pg_badge {
  opacity: 1;
  transform: translateY(0) scale(1);
  transition:
    opacity 0.6s ease 0.9s,
    transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.9s;
}

.impac_home_pg_slide_active .impac_home_pg_badge_bottom {
  transition-delay: 1.05s;
}

.impac_home_pg_badge_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #3b003d;
  color: #e0a83d;
}

.impac_home_pg_badge_text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.impac_home_pg_badge_value {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.1;
  color: #3b003d;
}

.impac_home_pg_badge_label {
  font-size: 12px;
  line-height: 1.4;
  color: #5d4a5f;
}

/* ============================================================
   Responsive — 1100 / 820 / 560
   ============================================================ */

@media (max-width: 1100px) {
  .impac_home_pg_slide {
    column-gap: 40px;
    padding: 56px 0 64px;
  }

  .impac_home_pg_badge {
    max-width: 210px;
    padding: 10px 14px;
  }
}

/* tablet: single column, text first, video below, centred */
@media (max-width: 820px) {
  .impac_home_pg_slide {
    grid-template-columns: minmax(0, 1fr);
    padding: 44px 0 56px;
  }

  .impac_home_pg_slide_prev,
  .impac_home_pg_slide_next {
    transform: translateY(24px);
  }

  .impac_home_pg_desc,
  .impac_home_pg_picker,
  .impac_home_pg_stats,
  .impac_home_pg_heading {
    max-width: 100%;
  }

  .impac_home_pg_slide {
    padding-top: 64px;
  }

  .impac_home_pg_visual {
    justify-self: center;
    max-width: 680px;
    padding-top: 72px; /* room for the top badge above the video */
  }

  .impac_home_pg_video_card {
    aspect-ratio: 16 / 10;
  }

  .impac_home_pg_badge_top {
    top: 0;
  }
}

/* phone: video stays visible, edge to edge, badges sit inside the card */
@media (max-width: 560px) {
  .impac_home_pg_stage {
    padding: 0 18px;
  }

  .impac_home_pg_slide {
    row-gap: 32px;
    padding: 32px 0 44px;
  }

  .impac_home_pg_desc {
    font-size: 15.5px;
    line-height: 1.7;
  }

  .impac_home_pg_chip {
    min-height: 42px;
    padding: 0 16px;
    font-size: 13.5px;
  }

  .impac_home_pg_actions {
    flex-direction: column;
    width: 100%;
  }

  .impac_home_pg_btn_primary,
  .impac_home_pg_btn_secondary {
    width: 100%;
  }

  .impac_home_pg_stats {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .impac_home_pg_visual {
    max-width: 100%;
    padding: 64px 0 24px;
  }

  .impac_home_pg_visual::before {
    display: none;
  }

  .impac_home_pg_video_card {
    aspect-ratio: 4 / 3.4;
    border-radius: 22px;
  }

  .impac_home_pg_slide_active .impac_home_pg_video_card,
  .impac_home_pg_video_card {
    clip-path: none;
  }

  .impac_home_pg_badge {
    max-width: 62%;
    padding: 8px 12px;
    border-radius: 12px;
  }

  .impac_home_pg_badge_top {
    top: 0;
    right: 0;
  }

  .impac_home_pg_badge_bottom {
    bottom: 10px;
    left: 10px;
  }

  .impac_home_pg_badge_icon {
    width: 32px;
    height: 32px;
  }

  .impac_home_pg_badge_value {
    font-size: 16px;
  }

  .impac_home_pg_badge_label {
    font-size: 11px;
  }

  /* phone: only icon in the sound button, card-oda top-right la */
  .impac_home_pg_sound_btn {
    top: 12px;
    right: 12px;
    bottom: auto;
    width: 42px;
    height: 42px;
    padding: 0;
    justify-content: center;
  }

  .impac_home_pg_sound_text {
    display: none;
  }
}

/* ---------- Reduced motion ---------- */

@media (prefers-reduced-motion: reduce) {
  .impac_home_pg_slide,
  .impac_home_pg_reveal,
  .impac_home_pg_chip,
  .impac_home_pg_video_card,
  .impac_home_pg_video,
  .impac_home_pg_badge,
  .impac_home_pg_visual::before {
    transition: opacity 0.2s ease !important;
    transition-delay: 0s !important;
    transform: none !important;
    clip-path: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA,gEAAgE;;AAEhE;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uDAAuD;EACvD,kBAAkB,EAAE,oCAAoC;EACxD,gBAAgB;EAChB,aAAa;EACb,qBAAqB,EAAE,uCAAuC;EAC9D,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB;;;6BAG2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,2CAA2C;;AAE3C;EACE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB;;+DAE6D;AAC/D;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2EAA2E;AAC7E;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iCAAiC;;AAEjC;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,uEAAuE;EACvE;;uCAEqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,uCAAuC;EACvC;;;;;;uBAMqB;AACvB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC;;;;;;qFAMmF;AACrF;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB;;uCAEqC;EACrC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;;EAEE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd;;uCAEqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE,oCAAoC,EAAE;EACzD,OAAO,UAAU,EAAE,6BAA6B,EAAE;AACpD;;AAEA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8FAA8F;AAChG;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,sFAAsF;AACxF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;sEACoE;EACpE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iFAAiF;EACjF,uCAAuC;EACvC,+BAA+B;EAC/B,wBAAwB,EAAE,8CAA8C;AAC1E;;AAEA;EACE,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uFAAuF;EACvF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,oBAAoB,EAAE,4CAA4C;AACpE;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA,yEAAyE;;AAEzE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,yCAAyC;EACzC,oBAAoB;EACpB,iCAAiC;EAEjC,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;EACxC,oBAAoB;EACpB;;;;wBAIsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;;AAE1C;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EAErC,2BAA2B;EAC3B,yCAAyC;EACzC,4CAA4C;EAC5C,UAAU;EACV,sCAAsC;EACtC,kDAAkD;AACpD;;AAEA,qDAAqD;AACrD;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,OAAO;AACT;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC;;yDAEuD;AACzD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB,EAAE,2CAA2C;EAChE;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,MAAM;EACR;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,MAAM;IACN,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,gEAAgE;EAChE;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;;AAEzC;EACE;;;;;;;IAOE,wCAAwC;IACxC,+BAA+B;IAC/B,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   HomePage — hero slider\n   Palette: purple #3b003d · gold #e0a83d · cream · soft lilac\n   No :root variables, no green.\n   ============================================================ */\n\n.impac_home_pg_section {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  background: linear-gradient(135deg, #ffffff 0%, #f8e9fd 100%);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  color: #3b003d;\n}\n\n.impac_home_pg_section::before {\n  content: \"\";\n  position: absolute;\n  top: -120px;\n  right: -140px;\n  width: 520px;\n  height: 520px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(224, 168, 61, 0.22) 0%, rgba(224, 168, 61, 0) 70%);\n  pointer-events: none;\n}\n\n/* ---------- Stage: all slides share one grid cell ---------- */\n\n.impac_home_pg_stage {\n  position: relative;\n  display: grid;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.impac_home_pg_slide {\n  grid-area: 1 / 1;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.08fr);\n  align-items: start; /* video top lines up with the tag */\n  column-gap: 56px;\n  row-gap: 40px;\n  padding: 100px 0 80px; /* top space also holds the top badge */\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition:\n    opacity 0.55s ease,\n    transform 0.7s cubic-bezier(0.22, 1, 0.36, 1),\n    visibility 0s linear 0.7s;\n}\n\n.impac_home_pg_slide_prev {\n  transform: translateX(-60px);\n}\n\n.impac_home_pg_slide_next {\n  transform: translateX(60px);\n}\n\n.impac_home_pg_slide_active {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(0);\n  transition-delay: 0s;\n  z-index: 2;\n}\n\n/* ---------- Staggered reveal ---------- */\n\n.impac_home_pg_reveal {\n  opacity: 0;\n  transform: translateY(26px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.impac_home_pg_slide_active .impac_home_pg_reveal {\n  opacity: 1;\n  transform: translateY(0);\n  transition:\n    opacity 0.7s ease var(--d, 0ms),\n    transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);\n}\n\n/* ---------- Left column ---------- */\n\n.impac_home_pg_info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n  width: 100%;\n}\n\n.impac_home_pg_tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  border-radius: 999px;\n  background: #ffffff;\n  border: 1px solid rgba(224, 168, 61, 0.55);\n  box-shadow: 0 4px 14px rgba(59, 0, 61, 0.08);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #3b003d;\n}\n\n.impac_home_pg_tag_text {\n  display: inline-block;\n  animation: impac_home_pg_tag_swap 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes impac_home_pg_tag_swap {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.impac_home_pg_tag_dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e0a83d;\n  box-shadow: 0 0 0 4px rgba(224, 168, 61, 0.25);\n}\n\n.impac_home_pg_heading {\n  margin: 20px 0 16px;\n  max-width: 640px;\n  font-size: clamp(28px, 3.3vw, 44px);\n  line-height: 1.15;\n  font-weight: 800;\n  letter-spacing: -0.015em;\n  color: #3b003d;\n  text-align: left;\n  text-wrap: balance;\n}\n\n.impac_home_pg_desc {\n  margin: 0 0 28px;\n  max-width: 600px;\n  font-size: 16.5px;\n  line-height: 1.75;\n  color: #4e3a50;\n  text-align: justify;\n  text-justify: inter-word;\n  hyphens: auto;\n  -webkit-hyphens: auto;\n  overflow-wrap: break-word;\n}\n\n/* ---------- Picker ---------- */\n\n.impac_home_pg_picker {\n  width: 100%;\n  max-width: 600px;\n  margin-bottom: 30px;\n}\n\n.impac_home_pg_question {\n  margin: 0 0 4px;\n  font-size: 17px;\n  font-weight: 800;\n  color: #3b003d;\n}\n\n.impac_home_pg_hint {\n  margin: 0 0 14px;\n  font-size: 13.5px;\n  color: #7a677c;\n  text-align: left;\n}\n\n.impac_home_pg_chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px 12px;\n}\n\n.impac_home_pg_chip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 44px;\n  padding: 0 22px;\n  border: 1px solid #e6dcfa;\n  border-radius: 8px;\n  background: #ffffff;\n  /* soft lilac \"step\" under the button + blurred glow, like the design */\n  box-shadow:\n    0 4px 0 -1px rgba(190, 168, 236, 0.55),\n    0 10px 18px rgba(74, 26, 158, 0.12);\n  font-family: inherit;\n  font-size: 14.5px;\n  font-weight: 700;\n  line-height: 1;\n  color: #4a1a9e;\n  cursor: pointer;\n  overflow: hidden;\n  isolation: isolate;\n  -webkit-tap-highlight-color: transparent;\n  opacity: 0;\n  transform: translateY(14px) scale(0.96);\n  transition:\n    background 0.3s ease,\n    color 0.3s ease,\n    border-color 0.3s ease,\n    box-shadow 0.3s ease,\n    opacity 0.2s ease,\n    transform 0.2s ease;\n}\n\n.impac_home_pg_slide_active .impac_home_pg_chip {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  transition:\n    background 0.3s ease,\n    color 0.3s ease,\n    border-color 0.3s ease,\n    box-shadow 0.3s ease,\n    opacity 0.5s ease calc(380ms + var(--i, 0) * 55ms),\n    transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) calc(380ms + var(--i, 0) * 55ms);\n}\n\n/* purple fill that sweeps in on hover */\n.impac_home_pg_chip::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);\n  transform: translateX(-101%);\n  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.impac_home_pg_slide_active .impac_home_pg_chip:hover {\n  color: #ffffff;\n  border-color: #40159f;\n  box-shadow:\n    0 4px 0 -1px rgba(122, 31, 196, 0.35),\n    0 14px 24px rgba(74, 26, 158, 0.32);\n  transform: translateY(-3px);\n  transition-delay: 0s;\n}\n\n.impac_home_pg_chip:hover::before {\n  transform: translateX(0);\n}\n\n.impac_home_pg_chip:active {\n  transform: scale(0.96);\n}\n\n/* arrow / tick inside the chip: always visible */\n.impac_home_pg_chip_icon {\n  flex-shrink: 0;\n  transition: transform 0.3s ease;\n}\n\n.impac_home_pg_chip:hover .impac_home_pg_chip_icon {\n  transform: translateX(3px);\n}\n\n.impac_home_pg_chip_selected .impac_home_pg_chip_icon {\n  animation: impac_home_pg_tick 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n.impac_home_pg_chip_selected,\n.impac_home_pg_slide_active .impac_home_pg_chip_selected:hover {\n  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);\n  border-color: #40159f;\n  color: #ffffff;\n  box-shadow:\n    0 4px 0 -1px rgba(122, 31, 196, 0.35),\n    0 12px 22px rgba(74, 26, 158, 0.34);\n}\n\n.impac_home_pg_chip_selected::before {\n  display: none;\n}\n\n.impac_home_pg_chip_selected:hover .impac_home_pg_chip_icon {\n  transform: none;\n}\n\n@keyframes impac_home_pg_tick {\n  from { opacity: 0; transform: scale(0.3) rotate(-30deg); }\n  to   { opacity: 1; transform: scale(1) rotate(0); }\n}\n\n.impac_home_pg_chip:focus-visible,\n.impac_home_pg_btn_primary:focus-visible,\n.impac_home_pg_btn_secondary:focus-visible,\n.impac_home_pg_sound_btn:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 3px;\n}\n\n/* ---------- Buttons ---------- */\n\n.impac_home_pg_actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-bottom: 38px;\n}\n\n.impac_home_pg_btn_primary,\n.impac_home_pg_btn_secondary {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px 28px;\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  overflow: hidden;\n  isolation: isolate;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n}\n\n.impac_home_pg_btn_primary {\n  border: 2px solid #3b003d;\n  background: #3b003d;\n  color: #faf6ec;\n  box-shadow: 0 10px 24px rgba(59, 0, 61, 0.28);\n}\n\n.impac_home_pg_btn_primary::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: #e0a83d;\n  transform: translateY(101%);\n  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.impac_home_pg_btn_primary:hover {\n  color: #3b003d;\n  border-color: #e0a83d;\n  transform: translateY(-3px);\n  box-shadow: 0 14px 30px rgba(224, 168, 61, 0.45);\n}\n\n.impac_home_pg_btn_primary:hover::before {\n  transform: translateY(0);\n}\n\n.impac_home_pg_btn_primary .impac_home_pg_arrow {\n  width: 14px;\n  margin-left: 0;\n  opacity: 1;\n}\n\n.impac_home_pg_btn_primary:hover .impac_home_pg_arrow {\n  transform: translateX(5px);\n}\n\n.impac_home_pg_btn_secondary {\n  border: 2px solid rgba(59, 0, 61, 0.3);\n  background: transparent;\n  color: #3b003d;\n}\n\n.impac_home_pg_btn_secondary:hover {\n  border-color: #3b003d;\n  background: #ffffff;\n  transform: translateY(-3px);\n  box-shadow: 0 10px 22px rgba(59, 0, 61, 0.14);\n}\n\n.impac_home_pg_btn_primary:active,\n.impac_home_pg_btn_secondary:active {\n  transform: translateY(0) scale(0.97);\n}\n\n/* ---------- Stats ---------- */\n\n.impac_home_pg_stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  width: 100%;\n  max-width: 640px;\n  padding-top: 26px;\n  border-top: 1px solid rgba(59, 0, 61, 0.14);\n}\n\n.impac_home_pg_stat {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.impac_home_pg_stat_value {\n  margin: 0 0 6px;\n  font-size: clamp(22px, 2.2vw, 30px);\n  font-weight: 800;\n  line-height: 1.1;\n  color: #3b003d;\n}\n\n.impac_home_pg_stat_label {\n  margin: 0 0 8px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #5d4a5f;\n  text-align: left;\n  hyphens: auto;\n  -webkit-hyphens: auto;\n}\n\n.impac_home_pg_stat_source {\n  margin-top: auto;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #b8861f;\n}\n\n/* ---------- Right: video ---------- */\n\n.impac_home_pg_visual {\n  position: relative;\n  justify-self: end;\n  align-self: start;\n  width: 100%;\n  max-width: 720px;\n  min-width: 0;\n  padding: 0 16px 30px 0;\n}\n\n/* gold frame sitting behind the card, offset down-right */\n.impac_home_pg_visual::before {\n  content: \"\";\n  position: absolute;\n  top: 16px;\n  right: 0;\n  bottom: 14px;\n  left: 16px;\n  border: 2px solid #e0a83d;\n  border-radius: 30px;\n  opacity: 0;\n  transform: translate(14px, -14px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.impac_home_pg_slide_active .impac_home_pg_visual::before {\n  opacity: 0.7;\n  transform: translate(0, 0);\n  transition: opacity 0.8s ease 0.5s, transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s;\n}\n\n.impac_home_pg_video_card {\n  position: relative;\n  width: 100%;\n  /* FIXED ratio: size never jumps when a video loads.\n     Video uses object-fit: cover so it always fills the whole card. */\n  aspect-ratio: 5 / 4;\n  border-radius: 28px;\n  overflow: hidden;\n  background: #3b003d;\n  box-shadow: 0 30px 60px rgba(59, 0, 61, 0.24), 0 0 0 1px rgba(224, 168, 61, 0.35);\n  clip-path: inset(0 0 100% 0 round 28px);\n  transition: clip-path 0.2s ease;\n  transform: translateZ(0); /* keeps rounded clipping on video in Safari */\n}\n\n.impac_home_pg_slide_active .impac_home_pg_video_card {\n  clip-path: inset(0 0 0 0 round 28px);\n  transition: clip-path 1.1s cubic-bezier(0.77, 0, 0.175, 1) 0.15s;\n}\n\n.impac_home_pg_video_card::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(59, 0, 61, 0) 60%, rgba(59, 0, 61, 0.32) 100%);\n  pointer-events: none;\n}\n\n.impac_home_pg_video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  min-height: 100%;\n  object-fit: cover;\n  object-position: center;\n  background: #3b003d;\n  transform: scale(1.12);\n  transition: transform 0.2s ease;\n  pointer-events: none; /* no native video controls/menus on hover */\n}\n\n.impac_home_pg_slide_active .impac_home_pg_video {\n  transform: scale(1);\n  transition: transform 1.6s cubic-bezier(0.22, 1, 0.36, 1) 0.15s;\n}\n\n.impac_home_pg_slide_active .impac_home_pg_video_card:hover .impac_home_pg_video {\n  transform: scale(1.04);\n  transition: transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* ---------- Sound button (inside video card, bottom-right) ---------- */\n\n.impac_home_pg_sound_btn {\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  z-index: 4;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 42px;\n  padding: 0 16px 0 12px;\n  border: 1px solid rgba(224, 168, 61, 0.6);\n  border-radius: 999px;\n  background: rgba(59, 0, 61, 0.72);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n  color: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  pointer-events: auto;\n  transition:\n    background 0.3s ease,\n    color 0.3s ease,\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.impac_home_pg_sound_btn:hover {\n  background: #e0a83d;\n  color: #3b003d;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);\n}\n\n.impac_home_pg_sound_btn:active {\n  transform: scale(0.96);\n}\n\n.impac_home_pg_sound_btn_on {\n  background: #e0a83d;\n  color: #3b003d;\n}\n\n.impac_home_pg_sound_btn_on:hover {\n  background: #ffffff;\n}\n\n.impac_home_pg_sound_btn svg {\n  flex-shrink: 0;\n}\n\n/* ---------- Floating badges ---------- */\n\n.impac_home_pg_badge {\n  position: absolute;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 18px;\n  max-width: 250px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.94);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(224, 168, 61, 0.5);\n  box-shadow: 0 16px 36px rgba(59, 0, 61, 0.2);\n  opacity: 0;\n  transform: translateY(20px) scale(0.9);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n/* sits fully above the video so it never covers it */\n.impac_home_pg_badge_top {\n  top: -72px;\n  right: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.impac_home_pg_badge_bottom {\n  bottom: 0;\n  left: 0;\n}\n\n.impac_home_pg_slide_active .impac_home_pg_badge {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  transition:\n    opacity 0.6s ease 0.9s,\n    transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.9s;\n}\n\n.impac_home_pg_slide_active .impac_home_pg_badge_bottom {\n  transition-delay: 1.05s;\n}\n\n.impac_home_pg_badge_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #3b003d;\n  color: #e0a83d;\n}\n\n.impac_home_pg_badge_text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.impac_home_pg_badge_value {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #3b003d;\n}\n\n.impac_home_pg_badge_label {\n  font-size: 12px;\n  line-height: 1.4;\n  color: #5d4a5f;\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .impac_home_pg_slide {\n    column-gap: 40px;\n    padding: 56px 0 64px;\n  }\n\n  .impac_home_pg_badge {\n    max-width: 210px;\n    padding: 10px 14px;\n  }\n}\n\n/* tablet: single column, text first, video below, centred */\n@media (max-width: 820px) {\n  .impac_home_pg_slide {\n    grid-template-columns: minmax(0, 1fr);\n    padding: 44px 0 56px;\n  }\n\n  .impac_home_pg_slide_prev,\n  .impac_home_pg_slide_next {\n    transform: translateY(24px);\n  }\n\n  .impac_home_pg_desc,\n  .impac_home_pg_picker,\n  .impac_home_pg_stats,\n  .impac_home_pg_heading {\n    max-width: 100%;\n  }\n\n  .impac_home_pg_slide {\n    padding-top: 64px;\n  }\n\n  .impac_home_pg_visual {\n    justify-self: center;\n    max-width: 680px;\n    padding-top: 72px; /* room for the top badge above the video */\n  }\n\n  .impac_home_pg_video_card {\n    aspect-ratio: 16 / 10;\n  }\n\n  .impac_home_pg_badge_top {\n    top: 0;\n  }\n}\n\n/* phone: video stays visible, edge to edge, badges sit inside the card */\n@media (max-width: 560px) {\n  .impac_home_pg_stage {\n    padding: 0 18px;\n  }\n\n  .impac_home_pg_slide {\n    row-gap: 32px;\n    padding: 32px 0 44px;\n  }\n\n  .impac_home_pg_desc {\n    font-size: 15.5px;\n    line-height: 1.7;\n  }\n\n  .impac_home_pg_chip {\n    min-height: 42px;\n    padding: 0 16px;\n    font-size: 13.5px;\n  }\n\n  .impac_home_pg_actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .impac_home_pg_btn_primary,\n  .impac_home_pg_btn_secondary {\n    width: 100%;\n  }\n\n  .impac_home_pg_stats {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .impac_home_pg_visual {\n    max-width: 100%;\n    padding: 64px 0 24px;\n  }\n\n  .impac_home_pg_visual::before {\n    display: none;\n  }\n\n  .impac_home_pg_video_card {\n    aspect-ratio: 4 / 3.4;\n    border-radius: 22px;\n  }\n\n  .impac_home_pg_slide_active .impac_home_pg_video_card,\n  .impac_home_pg_video_card {\n    clip-path: none;\n  }\n\n  .impac_home_pg_badge {\n    max-width: 62%;\n    padding: 8px 12px;\n    border-radius: 12px;\n  }\n\n  .impac_home_pg_badge_top {\n    top: 0;\n    right: 0;\n  }\n\n  .impac_home_pg_badge_bottom {\n    bottom: 10px;\n    left: 10px;\n  }\n\n  .impac_home_pg_badge_icon {\n    width: 32px;\n    height: 32px;\n  }\n\n  .impac_home_pg_badge_value {\n    font-size: 16px;\n  }\n\n  .impac_home_pg_badge_label {\n    font-size: 11px;\n  }\n\n  /* phone: only icon in the sound button, card-oda top-right la */\n  .impac_home_pg_sound_btn {\n    top: 12px;\n    right: 12px;\n    bottom: auto;\n    width: 42px;\n    height: 42px;\n    padding: 0;\n    justify-content: center;\n  }\n\n  .impac_home_pg_sound_text {\n    display: none;\n  }\n}\n\n/* ---------- Reduced motion ---------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .impac_home_pg_slide,\n  .impac_home_pg_reveal,\n  .impac_home_pg_chip,\n  .impac_home_pg_video_card,\n  .impac_home_pg_video,\n  .impac_home_pg_badge,\n  .impac_home_pg_visual::before {\n    transition: opacity 0.2s ease !important;\n    transition-delay: 0s !important;\n    transform: none !important;\n    clip-path: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
